/**
 * Public API barrel (Perf 3.1.b/e Step 6 — final wiring).
 *
 * The former monolith `lib/api.js` has been fully decomposed into leaf slices
 * under `lib/api/*`. This barrel only re-exports those leaves so existing
 * `@/lib/api` importers keep working unchanged. New code that wants the
 * smallest possible dependency graph should import the specific leaf instead
 * (e.g. `@/lib/api/useCases`).
 *
 * The shared network chokepoint (fetchWithAuth, ApiError, …) lives in
 * `lib/api/client.js`; import low-level helpers from there directly.
 */
export { ApiError, isAnonAuthError, isAbortedError, avatarUriToFile } from './client';

export { authApi } from './auth';
export { collectionsApi } from './collections';
export { chatsApi, inferencesApi } from './chats';
export { coworkerApi } from './coworker';
export { filesApi } from './files';
export { agentsApi } from './agents';
export { modelsApi } from './models';
export { toolsApi, toolRunsApi, toolCategoriesApi, toolTagsApi, toolStudiosApi } from './tools';
export { promptsApi, promptCategoriesApi } from './prompts';
export { companiesApi } from './companies';
export { exploreApi } from './explore';
export { decksApi } from './decks';
export { bookmarkFoldersApi } from './bookmarks';
export { creditPacksApi } from './creditPacks';
export { inferenceTasksApi } from './inferenceTasks';
export { taskTemplatesApi } from './taskTemplates';
export { accountApi } from './account';
export { deckTemplatesApi, deckTemplateCategoriesApi } from './deckTemplates';
export { useCasesApi } from './useCases';
export { usersApi } from './users';
export { mfaApi } from './mfa';
export { feedbackApi } from './feedback';
export { reportsApi } from './reports';
export { sitesApi, SITE_REPORT_REASONS } from './sites';
export { apiKeysApi } from './apiKeys';
export { voiceApi } from './voice';
export { whopApi } from './whop';
export { referralApi } from './referral';
export { bannerApi } from './banner';
export { dictateApi } from './dictate';
export { ttsApi } from './tts';
